<template>
  <div v-if="shouldShowButtons">
      <!-- Cores Remove Button -->
      <ButtonInertiaLink
          v-if="isCustomResourceTable"
          class="mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold"
          dusk="create-button"
          :href="
        $url(`/resources/histories`)
      "
      >
          <span class="inline-block">
        Cores Removed
      </span>
      </ButtonInertiaLink>
      <!-- Promotion button in customers tab -->
      <a
          v-if="resourceName === 'customers' && allResourcesLoaded"
          class="mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold shadow rounded focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring bg-primary-500 hover:bg-primary-400 active:bg-primary-600 text-white dark:text-gray-800 inline-flex items-center font-bold px-4 h-9 text-sm mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold"
          @click.prevent="promotionBtn"
          href="javascript:void(0)"
      >
          <span class="inline-block">Promotion</span>
      </a>
    <!-- Attach Related Models -->
    <ButtonInertiaLink
      class="shrink-0"
      v-if="shouldShowAttachButton"
      dusk="attach-button"
      :href="
        $url(
          `/resources/${viaResource}/${viaResourceId}/attach/${resourceName}`,
          {
            viaRelationship,
            polymorphic: relationshipType === 'morphToMany' ? '1' : '0',
          }
        )
      "
    >
      <slot>
        <span class="hidden md:inline-block">
          {{ __('Attach :resource', { resource: singularName }) }}
        </span>
        <span class="inline-block md:hidden">
          {{ __('Attach') }}
        </span>
      </slot>
    </ButtonInertiaLink>

    <!-- Create Related Models -->
    <ButtonInertiaLink
      v-else-if="shouldShowCreateButton"
      class="shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold"
      dusk="create-button"
      :href="
        $url(`/resources/${resourceName}/new`, {
          viaResource: viaResource,
          viaResourceId: viaResourceId,
          viaRelationship: viaRelationship,
          relationshipType: relationshipType,
        })
      "
    >
      <span class="hidden md:inline-block">
        {{ label }}
      </span>
      <span class="inline-block md:hidden">
        {{ __('Create') }}
      </span>
    </ButtonInertiaLink>

      <PasswordConfirmModal
          :show="confirmPasswordModal"
          @close="closePasswordModal"
      />
  </div>
</template>

<script setup>
import { useLocalization } from '@/composables/useLocalization'
import { computed } from 'vue'
import { ref } from 'vue'
import PasswordConfirmModal from "./Modals/PasswordConfirmModal.vue";

const { __ } = useLocalization()

const props = defineProps({
  type: {
    type: String,
    default: 'button',
    validator: val => ['button', 'outline-button'].includes(val),
  },
  label: {},
  singularName: {},
  resourceName: {},
  viaResource: {},
  viaResourceId: {},
  viaRelationship: {},
  relationshipType: {},
  authorizedToCreate: {},
  authorizedToRelate: {},
    allResourcesLoaded: {
        type: Boolean,
        default: false,
    },
    isCustomResourceTable: {
        type: Boolean,
        default: false,
    },
  alreadyFilled: { type: Boolean, default: false },
})

const confirmPasswordModal = ref(false)

const shouldShowAttachButton = computed(() => {
  return (
    (props.relationshipType === 'belongsToMany' ||
      props.relationshipType === 'morphToMany') &&
    props.authorizedToRelate
  )
})

const shouldShowCreateButton = computed(() => {
  return (
    props.authorizedToCreate && props.authorizedToRelate && !props.alreadyFilled
  )
})

const shouldShowButtons = computed(() => {
  return shouldShowAttachButton || shouldShowCreateButton
})

const promotionBtn = () => {
    confirmPasswordModal.value = true
}

const closePasswordModal = () => {
    confirmPasswordModal.value = false
}
</script>
